<template>
  <div class="wide-quote">
    <section
      :class="{
        'page-section': true,
        'hero-bg': !!backgroundImage
      }"
    >
      <div class="container">
        <div class="quote-image"></div>
        <div class="quote-container">
          <commonModal
            :show="showErrorModal"
            :actionButton="true"
            :options="{
              title: 'Sorry!',
              description: `We were unable to locate your quote using that information. To try again, please close this window, or you may click the button below to begin a new quote.`,
              buttonLabel: 'New Quote'
            }"
            @close="clickedCloseOnModal"
          ></commonModal>
          <form class="quote-hero has-placeholders" method="post" action="/">
            <fieldset
              :class="{
                columns: openRetrieveQuote,
                'form-fields': true
              }"
            >
              <legend class="is-bold" v-if="!openRetrieveQuote">
                {{ title }}
              </legend>
              <div class="select-wrapper" v-if="!openRetrieveQuote">
                <p v-html="subtitle" class="subtitle"></p>
                <v-select
                  v-if="showState"
                  v-model="quoteState"
                  :searchable="true"
                  :options="stateOptions"
                  :class="'quote-select__white'"
                  id="state"
                  name="state"
                  placeholder="Select your state"
                ></v-select>
              </div>

              <div class="buttons-wrapper" v-if="!openRetrieveQuote">
                <button
                  @click="startQuote"
                  type="button"
                  class="button-primary button-primary--white -spacing-c"
                  v-if="!openRetrieveQuote"
                >
                  <span class="button-primary__label no-icon"
                    >Start a tailored quote</span
                  >
                </button>
                <button
                  v-if="!openRetrieveQuote"
                  @click="resumeQuote"
                  type="button"
                  class="button-primary second-button  button-primary--white -spacing-c"
                >
                  <span class="button-primary__label no-icon">
                    Retrieve my quote
                  </span>
                </button>
              </div>
              <legend v-if="openRetrieveQuote">Retrieve your quote</legend>
              <div v-if="openRetrieveQuote" class="column input-container">
                <label class="input">
                  <input
                    v-model="emailAddress"
                    name="emailAddress"
                    :class="{
                      input__field: true,
                      error: errors.has('emailAddress')
                    }"
                    placeholder="Email Address"
                    v-validate="'required|email'"
                  />

                  <span class="input__label">Email Address</span>
                </label>
                <div class="limit-container -spacing-f">
                  <label class="input">
                    <masked-input
                      :class="{
                        input__field: true,
                        error: errors.has('dateOfBirth')
                      }"
                      type="text"
                      name="dateOfBirth"
                      placeholder="Date of birth (MM/DD/YYYY)"
                      v-model="dateOfBirth"
                      @blur="checkWorking('dateOfBirth', dateOfBirth)"
                      :keepCharPositions="true"
                      v-validate="'required|validate18YrsOld|isLeapYear'"
                      :placeholderChar="'_'"
                      :pipe="autoCorrectedDatePipe"
                      :mask="[
                        /\d/,
                        /\d/,
                        '/',
                        /\d/,
                        /\d/,
                        '/',
                        /\d/,
                        /\d/,
                        /\d/,
                        /\d/
                      ]"
                      :guide="true"
                    ></masked-input>
                    <span class="input__label">Date of birth (MM/DD/YYYY)</span>
                  </label>
                  <b-icon
                    pack="fas"
                    icon="calendar"
                    class="calendar-icon"
                  ></b-icon>
                  <b-datepicker
                    name="dateOfBirth1"
                    @input="changedDOB"
                    v-model="selectedDate"
                    :max-date="validationOptions.atleastEighteenYrsOld"
                    :focused-date="validationOptions.atleastEighteenYrsOld"
                    :mobile-native="false"
                    data-vv-validate-on="input|blur"
                  ></b-datepicker>
                </div>
                <label class="input -spacing-f">
                  <input
                    v-model="zipCode"
                    name="zipcode"
                    maxlength="5"
                    @paste="onPaste"
                    @input="onlyNumbers"
                    :class="{
                      input__field: true,
                      error: errors.has('zipcode')
                    }"
                    placeholder="ZIP Code"
                    v-validate="'required|numeric|length:5'"
                    data-vv-validate-on="input|blur"
                  />

                  <span class="input__label">ZIP Code</span>
                </label>
              </div>
              <div
                v-if="openRetrieveQuote"
                :class="{
                  'buttons-wrapper': true,
                  column: true
                }"
              >
                <button
                  @click="openRetrieveQuote = !openRetrieveQuote"
                  type="button"
                  class="button-primary button-primary--white -spacing-f retrieve-button"
                >
                  <span class="no-icon">Back</span>
                </button>
                <button
                  @click="resumeQuote"
                  type="button"
                  class="button-primary  button-primary--white -spacing-f retrieve-button"
                >
                  <span class="button-primary__label no-icon">
                    See my quote
                  </span>
                </button>
              </div>
            </fieldset>
            <p class="subtitle">
              or call
              <span style="white-space: nowrap"
                ><a
                  style="text-decoration:underline;color:#fff"
                  href="tel:1-800-400-4128"
                  >800-400-4128</a
                ></span
              >
              to get started
            </p>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import commonModal from '../shared/commonModal';
import moment from 'moment';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';

export default {
  name: 'QuoteWide',
  props: {
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    showState: {
      type: Boolean,
      example: true
    },
    backgroundImage: {
      type: String
    },
    screenSize: {
      type: String
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn']),
    autoCorrectedDatePipe() {
      return createAutoCorrectedDatePipe('mm/dd/yyyy');
    }
  },
  components: {
    commonModal
  },
  methods: {
    ...mapMutations([
      'updateForm',
      'setSelectedPolicy',
      'updateQuoteResponse',
      'toggleLoader'
    ]),
    ...mapActions(['fetchQuote']),
    FLOOD1() {
      if (
        process.env.VUE_APP_ENV.toLowerCase() !== 'production' &&
        process.env.VUE_APP_ENV.toLowerCase() !== 'prod'
      ) {
        return;
      }
      // console.log('Floodlight 1 Active');
      // USA_Porsche_DCM_Floodlight_PAI_Homepage_StartQuote_ButtonClick
      let axel = Math.random() + '';
      let a = axel * 10000000000000;
      let flDiv = document.body.appendChild(document.createElement('div'));
      let GDPR = '${GDPR}';
      let GDPR_CONSENT_755 = '${GDPR_CONSENT_755}';
      flDiv.setAttribute('id', process.env.VUE_APP_FLOODLIGHT_ID);
      flDiv.style.position = 'absolute';
      flDiv.style.top = '0';
      flDiv.style.left = '0';
      flDiv.style.width = '1px';
      flDiv.style.height = '1px';
      flDiv.style.display = 'none';
      flDiv.innerHTML = `<iframe id=${process.env.VUE_APP_FLOODLIGHT_ID +
        '_FLIframe2'} src="https://5368208.fls.doubleclick.net/activityi;src=5368208;type=porsc00c;cat=usa_p001;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=${a}?" width="1" height="1" frameborder="0"></iframe>`;
    },
    startQuote() {
      this.FLOOD1();
      if (
        this.quoteState === null ||
        this.quoteState.value === 'AZ' ||
        this.quoteState.value === 'FL' ||
        this.quoteState.value === 'GA' ||
        this.quoteState.value === 'OH' ||
        this.quoteState.value === 'OR' ||
        this.quoteState.value === 'TN' ||
        this.quoteState.value === 'TX'
      ) {
        let payload = {
          info: {
            state: this.quoteState
              ? { label: this.quoteState.label, value: this.quoteState.value }
              : null,
            zipCode: null
          },
          vehicles: [],
          drivers: [],
          coverage: {}
        };
        this.updateForm(payload);
        this.$router.push('/receive-a-quote');
      } else if (
        this.quoteState.value === 'CA' ||
        this.quoteState.value === 'FL' ||
        this.quoteState.value === 'IL' ||
        this.quoteState.value === 'OH' ||
        this.quoteState.value === 'OR' ||
        this.quoteState.value === 'PA' ||
        this.quoteState.value === 'TN' ||
        this.quoteState.value === 'TX' ||
        this.quoteState.value === 'WI'
      ) {
        this.$router.push('/unavailable?not-writing');
      } else {
        this.$router.push({
          name: 'Unavailable',
          query: { state: this.quoteState.label }
        });
      }
    },
    checkWorking(key, value) {
      let validator = this.$validator;
      validator.validate(key, value);
    },

    FLOOD2() {
      if (
        process.env.VUE_APP_ENV.toLowerCase() !== 'production' &&
        process.env.VUE_APP_ENV.toLowerCase() !== 'prod'
      ) {
        return;
      }
      // console.log('Floodlight 2 Active');
      // USA_Porsche_DCM_Floodlight_PAI_Homepage_RetrieveQuote_ButtonClick
      let axel = Math.random() + '';
      let a = axel * 10000000000000;
      let flDiv = document.body.appendChild(document.createElement('div'));
      let GDPR = '${GDPR}';
      let GDPR_CONSENT_755 = '${GDPR_CONSENT_755}';
      flDiv.setAttribute('id', process.env.VUE_APP_FLOODLIGHT_ID);
      flDiv.style.position = 'absolute';
      flDiv.style.top = '0';
      flDiv.style.left = '0';
      flDiv.style.width = '1px';
      flDiv.style.height = '1px';
      flDiv.style.display = 'none';
      flDiv.innerHTML = `<iframe id=${process.env.VUE_APP_FLOODLIGHT_ID +
        '_FLIframe2'} src="https://5368208.fls.doubleclick.net/activityi;src=5368208;type=porsc00c;cat=usa_p000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=${a}?" width="1" height="1" frameborder="0"></iframe>`;
    },

    resumeQuote() {
      this.FLOOD2();
      if (!this.isLoggedIn && !this.openRetrieveQuote) {
        this.openRetrieveQuote = true;
        return;
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.isLoggedIn) {
            this.$router.push('/account/lookup-quotes');
          } else {
            //guest user case goes here
            this.fetchPolicy();
          }
        } else {
          event.preventDefault();
        }
      });
    },

    fetchPolicy() {
      if (this.emailAddress && this.dateOfBirth && this.zipCode) {
        this.toggleLoader({
          loaderText: 'Please wait while we retrieve your information.'
        });
        let request = {
          emailAddress: this.emailAddress,
          dob: moment(this.dateOfBirth, 'MM/DD/YYYY').format('YYYY-MM-DD'),
          zip: this.zipCode
        };
        this.fetchQuote(request)
          .then(() => {
            this.toggleLoader();
            this.$router.push({
              path: '/receive-a-quote',
              query: {
                email: this.emailAddress.toLowerCase(),
                dob: moment(this.dateOfBirth, 'MM/DD/YYYY').format(
                  'YYYY-MM-DD'
                ),
                zipcode: this.zipCode
              }
            });
          })
          .catch(() => {
            this.toggleLoader();
            // message: `We were unable to locate your quote using that information. To try again, please close this window, or you may click the button below to begin a new quote.`,
            this.openRetrieveQuote = !this.openRetrieveQuote;
            // this.$snackbar.open({
            //   type: 'is-danger',
            //   message: `We were unable to locate your quote. Please click the button 'Start a new quote' to begin a new quote.`,
            //   position: 'is-bottom'
            // });
            this.showErrorModal = !this.showErrorModal;
          });
      }
    },

    clickedCloseOnModal(value) {
      this.showErrorModal = false;
      if (value === 1) {
        this.$router.push('/receive-a-quote');
      }
    },

    onPaste(event) {
      event.clipboardData.getData('text/plain').slice(0, 5);
    },

    onlyNumbers() {
      this.zipCode = this.zipCode.toString().replace(/[^0-9]/g, '');
    },
    changedDOB(event) {
      this.dateOfBirth = moment(event).format('MM/DD/YYYY');
      this.selectedDate = null;
      this.$el.querySelector('[name="dateOfBirth"]').focus();
      this.$validator.validate('dateOfBirth', this.dateOfBirth);
    }
  },
  data: () => ({
    quoteState: null,
    stateOptions: [
      {
        label: 'Arizona',
        value: 'AZ'
      },
      {
        label: 'Florida',
        value: 'FL'
      },
      {
        label: 'Georgia',
        value: 'GA'
      },
      {
        label: 'Oregon',
        value: 'OR'
      },
      {
        label: 'Tennessee',
        value: 'TN'
      },
      {
        label: 'Texas',
        value: 'TX'
      }
    ],
    openRetrieveQuote: false,
    emailAddress: null,
    dateOfBirth: '',
    zipCode: null,
    selectedDate: null,
    showErrorModal: false,
    validationOptions: {
      dateOfBirth: {
        date: true,
        datePattern: ['m', 'd', 'Y'],
        delimiter: '/'
      },
      atleastEighteenYrsOld: new Date(
        new Date().setFullYear(new Date().getFullYear() - 18)
      )
    }
  })
};
</script>

<style lang="scss" scoped>
div.wide-quote {
  background-color: $porcelain;
  min-height: 300px;
}
section {
  position: relative;
  min-height: 325px;
  //overflow: hidden;
  padding: 32px 0;

  @media (max-width: 720px) {
    min-height: 250px;
  }
}

.container {
  min-height: 250px;
}

section.hero-bg {
  color: $white;
}

.quote-container {
  position: absolute;
  top: 0;
  max-width: 100%;
  padding: 15px 25px;
  font-size: 1rem;
  line-height: 1.5rem;

  @media (min-width: 400px) {
    max-width: 85%;
  }
  @media (min-width: 760px) {
    max-width: 75%;
  }
  @media (min-width: 1299px) {
    max-width: 65%;
  }
}

.quote-image {
  border-radius: 12px;
  min-height: 325px;
  background: url('~@/assets/img/homepage/PAI_Landing-Page_Mobile_12.jpg')
    center no-repeat;
  background-size: cover;
  box-shadow: 0px 8px 40px rgba(0, 0, 0, 0.16);

  @media (min-width: 400px) {
    background-image: url('~@/assets/img/homepage/PAI_Landing-Page_Desktop_12.jpg');
  }
}
legend {
  font-family: $family-sans-serif;
  font-size: 2rem;
  line-height: 2.25rem;
  font-weight: 600;
  @media (min-width: 1300px) {
    font-size: 2rem;
  }
}
.state-label {
  font-size: 16px;
  line-height: 24px;
}
.subtitle {
  color: $white;
  margin: 0.25em 0;
  font-size: 0.85em;
  line-height: 20px;
  @media (max-width: 420px) {
    margin: 0;
  }
}

form {
  margin-top: 0.5rem;
  @media (max-width: 420px) {
    width: 90%;
  }

  .form-fields {
    padding: 0.75rem 0;
  }
  .columns {
    max-height: 300px;
  }
  .column {
    max-height: 225px;
    padding: 0;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  label {
    //margin-top: 30px;
  }
  .button-primary {
    margin: 0.5rem 0.5rem 0.5rem 0;
    font-size: 16px;

    @media (max-width: 480px) {
      margin: 0.25rem 0.25rem 0.25rem 0;
    }
  }
  .button-primary + .button-primary {
    &.retrieve-button {
      margin: 0.5rem 0 0;

      @media (max-width: 760px) {
        margin: 0 0 0 0.5rem;
      }
    }
  }
  .back-button {
    background-color: transparent;
  }
  .select-wrapper {
    margin: 0.5rem 0;

    @media (max-width: 480px) {
      margin: 0.25rem 0;
    }
    div#state.quote-select {
      .dropdown-toggle {
      }
      .dropdown-menu {
        max-height: 170px !important;
      }
    }
  }
  .buttons-wrapper.column {
    padding: 0;
    margin-left: 0.5rem;
    align-items: start;
    flex-direction: column;

    @media (max-width: 760px) {
      flex-direction: row;
      margin: 0.5rem 0 0;
    }
  }
  .buttons-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    button {
      text-align: center;

      span {
        margin: 0 auto;
      }
    }
    .retrieve-button {
      max-height: 46px;
      margin: 0;
      width: 100%;

      @media (max-width: 760px) {
        width: unset;
      }
    }
  }
  hr {
    background: #3c4144;
    height: 1px;
  }
}
</style>
